// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "code-example" + "." + "6b97dde4" + ".chunk.js";
};